
<div class="simpletable">
    <nz-table #varTable nzSize="small" [nzData]="dataSource || []"
        [nzFrontPagination]="false" [nzShowPagination]="false">
        <thead>
            <tr>
                <th *ngFor="let column of columns">{{columnsToDisplay.get(column)}}</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let element of varTable.data">
                <tr class="example-element-row"
                    [class.example-expanded-row]="expandedElement === element"
                    (click)="expandedElement = element">
                    <td *ngFor="let column of columns">{{element[column]}}</td>
                </tr>
                <tr class="example-detail-row">
                    <td [attr.colspan]="columns.length">
                        <div class="example-element-detail"
                            [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                            <div class="data-expanded">
                                <div class="left">
                                    <carousel  cellsToShow="1" loop="true" width="200" >
                                        <div class="carousel-cell" *ngFor="let image of element.picture_ids">
                                            <img [src]="getLinkImage(image)">
                                        </div>
                                    </carousel>
                                </div>
                                <div class="right">
                                    <h2>{{'meli.form.attributes'|translateTA}}</h2>
                                    <ul>
                                        <li *ngFor="let item of element.attribute_combinations">
                                            <b>{{item.name}}:</b> {{item.value_name}}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </nz-table>
</div>
